import React, { useEffect, useState } from "react";
import PageHeader from "../../../PageHeader";
import BodyPartTableWrapper from "./BodyPartTableWrapper";
import { Link } from "react-router-dom";
import { api } from "../../../../api/api";
import useAxios from "../../../../api/useAxios";
import Swal from "sweetalert2";
import BodyEditModal from "./BodyEditModal";
import BodyPartHeader from "./BodyPartHeader";
import { confirmAlert } from "react-confirm-alert";
import { useDispatch, useSelector } from "react-redux";
import { setData } from "../../../../redux/bodyPart/bodyPartSlice";

const BodyPartList = () => {
  const instance = useAxios();
  // const [data, setData] = useState([]);
  const data = useSelector((state) => state.bodyPart?.data);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [openEdit, setOpenEdit] = useState(false);
  const dispatch = useDispatch();

  const handleClose = (response) => {
    setOpenEdit(false);
    setSelectedItem(null);
    if (response) {
      const updatedData = data.map((item) => {
        if (item._id === response._id) {
          return response;
        }
        return item;
      });
      dispatch(setData(updatedData));
      // setData(updatedData);
    }
  };

  const handleOpenEdit = (item) => {
    setSelectedItem(item);
    setOpenEdit(true);
  };

  const handleDeleteConfirm = (id) => {
    confirmAlert({
      title: "Confirm to submit",
      message: "Are you sure to do this.",
      buttons: [
        {
          label: "Yes",
          onClick: () => handleDelete(id),
        },
        {
          label: "No",
        },
      ],
    });
  };

  const handleDelete = (id) => {
    instance
      .delete("/body-part/" + id)
      .then((response) => {
        Swal.fire({
          title: "Success",
          text: "Successfully Deleted!",
          icon: "success",
          confirmButtonText: "OK",
        });
        const result = data.filter((item) => item._id !== id);
        dispatch(setData(result));
        // setData(result);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error.response.data.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      });
  };

  console.log("rerender when state update", data);
  useEffect(() => {
    const getBodyParts = async () => {
      setIsLoading(true);
      try {
        const response = await instance.get("/body-parts");
        setIsLoading(false);

        dispatch(setData(response.data?.data));
        // setData(response.data.data);
      } catch (error) {
        setIsLoading(false);
        Swal.fire({
          title: "Error",
          text: "Something Went Wrong",
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      }
    };

    getBodyParts();
  }, []);
  
  return (
    <>
      <PageHeader title={"Body Part List"} />
      <BodyPartHeader />
      <BodyPartTableWrapper
        isLoading={isLoading}
        data={data}
        handleOpenEdit={handleOpenEdit}
        handleDeleteConfirm={handleDeleteConfirm}
      />

      {selectedItem && (
        <BodyEditModal
          selectedItem={selectedItem}
          open={openEdit}
          handleClose={handleClose}
        />
      )}
    </>
  );
};

export default BodyPartList;
